import React from 'react';

function Instagram(props) {

  return (
    <svg version="1.1" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <path d="m5 0a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5zm110 0a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5zm-55.639 11.828c-27.655 0-48.809 20.995-48.809 48.65 0 47.479-0.088298 47.693 33.795 47.693l31.643-0.03907c33.499 0 33.457 0.11617 33.457-47.654 0-27.655-22.431-48.65-50.086-48.65zm22.328 18.074a6.8662 6.8662 0 0 1 6.8652 6.8672 6.8662 6.8662 0 0 1-6.8652 6.8652 6.8662 6.8662 0 0 1-6.8672-6.8652 6.8662 6.8662 0 0 1 6.8672-6.8672zm-21.689 14.762c15.079 0 27.41 12.33 27.41 27.408s-12.332 27.41-27.41 27.41c-15.079 0-27.41-12.332-27.41-27.41s12.332-27.408 27.41-27.408zm0 10c-9.6742 0-17.41 7.734-17.41 17.408s7.736 17.41 17.41 17.41 17.41-7.736 17.41-17.41-7.736-17.408-17.41-17.408zm-55 55.336a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5zm110 0a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5z" stroke-width=".19939"/>
    </svg>
  );

}

export default Instagram;